import {GameStateEnums} from '../../../../../shared/GameEnums.ts'
import {type UIGameManager} from '../UIGameManager.ts'
import {type UIGameMechanic} from '../UIGameEventController.ts'
import {type PlayerValidator, MechanicValidatorLargestArmy, MechanicValidatorDevelopmentCard} from '@colonist/game-mechanic-validators'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils.ts'
import {CardEnum, type MechanicDevelopmentCardsState, type MechanicLargestArmyState, type PlayerColor} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {type UIGameAddAchievementEvent} from '@colonist/ui-game'

export class UIGameLargestArmyController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    private readonly largestArmyValidator: MechanicValidatorLargestArmy
    private readonly developmentCardsValidator: MechanicValidatorDevelopmentCard | undefined

    private lastPlayerToHoldLargestArmy: PlayerColor

    constructor(uiGameManager: UIGameManager, largestArmyState: MechanicLargestArmyState, developmentCardsState: MechanicDevelopmentCardsState | undefined) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.largestArmyValidator = new MechanicValidatorLargestArmy(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, largestArmyState)
        this.developmentCardsValidator = developmentCardsState ? new MechanicValidatorDevelopmentCard(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, developmentCardsState) : undefined

        this.lastPlayerToHoldLargestArmy = this.largestArmyValidator.getPlayerWithLargestArmy()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated: this.updateLargestArmyStatus(data); break
            default: break
        }
    }

    private updateLargestArmyStatus(animate: boolean) {
        for(const player of this.uiGameManager.gameState.players) {
            if(!this.largestArmyValidator.getLargestArmyPlayerState(player.color).hasLargestArmy) continue
            if(player.color == this.lastPlayerToHoldLargestArmy) continue

            this.playerAchievedLargestArmy(player, animate)
        }
    }

    private playerAchievedLargestArmy(playerState: PlayerValidator, animate: boolean) {
        const developmentCardsUsed = this.developmentCardsValidator?.getDevelopmentCardsPlayerState(playerState.color).developmentCardsUsed ?? []
        const knightDevelopmentCardsUsedCount = ArrayUtils.countOccurenceOfValueInArray(developmentCardsUsed, CardEnum.Knight)

        const achievement: UIGameAddAchievementEvent = {
            achievementOwnerNew: playerState.color,
            achievementOwnerPrevious: this.lastPlayerToHoldLargestArmy,
            achievementType: 'LargestArmy',
            achievementScore: knightDevelopmentCardsUsedCount,
        }

        this.lastPlayerToHoldLargestArmy = playerState.color

        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement)
    }
}
